import AddressPredictionItem from '@porterin/booking-flow/src/order-review/view/components/AddressPredictionItem';
import PredictionsSectionTitle from '@porterin/booking-flow/src/order-review/view/components/PredictionsSectionTitle';
import { OrderReviewLabels } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewStore';
import React from 'react';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import { GaEventsLocationAccuracy } from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { publishEventParameter } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import {
  getScreenName,
  isDesktop,
} from '@porterin/lead-flow/src/components/FareEstimateHelper';

export interface AddressPredictionsCmpProps {
  predictions: google.maps.places.AutocompletePrediction[];
  on_prediction_click: (
    prediction: google.maps.places.AutocompletePrediction,
  ) => void;
}

const AddressPredictionsCmp: React.FC<AddressPredictionsCmpProps> = ({
  predictions,
  on_prediction_click,
}) => {
  const { state } = useLocation();

  return (
    <div className="mt-[1.2rem] bg-white p-[1.2rem]">
      <PredictionsSectionTitle
        text={OrderReviewLabels.predictionsTitle}
        id="predictions-title"
      />
      {predictions.map(address => (
        <AddressPredictionItem
          key={address.place_id}
          main_text={address.structured_formatting.main_text}
          secondary_text={address.structured_formatting.secondary_text}
          on_click={() => {
            on_prediction_click(address);
            try {
              publishEventParameter(
                state?.waypoint === 'Pickup'
                  ? GaEventsLocationAccuracy.pickupSelectFromSearch
                  : GaEventsLocationAccuracy.dropSelectFromSearch,
                {
                  category: 'Location Accuracy',
                  device: isDesktop() ? 'Desktop' : 'mobile',
                  screen_name: getScreenName(),
                },
              );
            } catch (e) {
              console.error('Error publishing event', e);
            }
          }}
        />
      ))}
    </div>
  );
};

export default AddressPredictionsCmp;
